export const isValidDate = (dateStr: string): boolean => {
  const regex = /^(\d{2})\/(\d{2})\/(\d{4})$/;
  const match = dateStr.match(regex);
  if (!match) return false;
  
  const [, month, day, year] = match;
  const date = new Date(parseInt(year), parseInt(month) - 1, parseInt(day));
  return date.getMonth() === parseInt(month) - 1 && 
         date.getDate() === parseInt(day) &&
         date.getFullYear() === parseInt(year);
};
